import logo from './logo192.png';
import './App.css';

function App() {
  return (
      <div className="App">
          <header className="App-header">
              <img src={logo} className="App-logo" alt="logo"/>
              {/* The paragraph and link elements have been removed */}

              <div style={{
                  border: '1px solid #ccc',
                  padding: '15px',
                  margin: '20px 0',
                  borderRadius: '8px',
                  backgroundColor: '#f9f9f9',
                  fontFamily: 'Arial, sans-serif',
                  textAlign: 'center',
              }}>
                  <p style={{
                      margin: '0 0 10px 0',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      color: '#333',
                  }}>
                      Connect with us using chat.
                  </p>
                  <p style={{
                      margin: 0,
                      fontSize: '18px',
                      color: '#007bff',
                  }}>
                      Or Talk to us on
                      <a
                          href="tel:+919800189595"
                          style={{
                              textDecoration: 'none',
                              color: '#007bff',
                              fontWeight: 'bold',
                          }}
                      >
                          +91-9800189595
                      </a>
                  </p>
              </div>
          </header>
      </div>
  );
}

export default App;
